// extracted by mini-css-extract-plugin
export default {"boxErrorMsg":"UU-z","blockMsg":"VU-z","blockErrorMsg":"WU-z"};